import axios from 'axios'
import {Message, MessageBox} from 'element-ui'
import Qs from 'qs'

// let loading
// const getQueryString = function(name) {
//   var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)', 'i');
//   var r = window.location.search.substr(1).match(reg);
//   if (r != null) {
//       return unescape(r[2]);
//   }
//   return null;
// }
const backUrl= function(){

  // console.log(b)
  // let a=process.env.NODE_ENV = 'production'
  //   ? window.location.origin + '/m/login?url='+encodeURIComponent(location.href)
  //   : window.location.origin + '/login?url='+encodeURIComponent(location.href)
  // let phone = getQueryString("phone");
  // return window.location.origin + '/#/login'
  localStorage.removeItem('_$_zzb-access-token')
  top.window.location.href = window.location.origin + (process.env.NODE_ENV === 'production'?'/login':'/tfweb/login')
}
let http = axios.create({
  // process.env.NODE_ENV === 'production' || process.env.NODE_ENV === 'test'
  baseURL: process.env.NODE_ENV === 'production'?'/api/':'/tf/',
  // withCredentials: true,
  headers: {'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8'}
})
// console.log(process.env.NODE_ENV)
// 配置发送请求前的拦截器 可以设置token信息
http.interceptors.request.use(config => {
  // Toast.loading({
  //   duration: 0, // 持续展示 toast
  //   forbidClick: true,
  //   message: '加载中...',
  // });
  if (localStorage.getItem('_$_zzb-access-token')) {
    config.headers.common['zzb-access-token'] = `${localStorage.getItem('_$_zzb-access-token')}`
  }
  return config
}, error => {
  return Promise.reject(error)
})
// 配置响应拦截器
http.interceptors.response.use(
  res => {
    // loading.close()
    //   alert(res.headers['zzb-access-token'])
    if (res.headers['zzb-access-token']) {
      let token = res.headers['zzb-access-token']
      localStorage.setItem('_$_zzb-access-token', token)
    }
    localStorage.setItem("response_header",JSON.stringify(res.headers));
    // console.log(res.headers)
    if(res.headers['zzb_auth_button']){
      // console.log("设置over", res.headers['zzb_auth_button'])
      localStorage.setItem('over', res.headers['zzb_auth_button'])
      if(res.headers['zzb_auth_button'].indexOf("ADMIN_DOC")>-1){
        res.data.isAdmin=true
      }
    }
    // Toast.clear()
    return Promise.resolve(res.data)
  },
  error => {
    // Toast.clear()
    if (error.response.status === 401) {
      MessageBox.alert('登陆失效，请重新登陆！', '警告', {
        confirmButtonText: '确定',
        callback: action => {
          backUrl()
        }
      })
      // top.window.location.href = window.location.origin + '/#/login'

    } else if (error.response.status === 500) {
      if (error.response.data) {
        if (error.response.data.code) {
          Message.error(error.response.data.msg)
          if (error.response.data.code === 'E1001') {
            backUrl()
          }
        } else {
          Message.error('服务器错误')
        }
      } else {
        Message.error('服务器错误')
      }
    } else if (error.response.status === 504 || error.response.status === 502) {
      Message.error('服务器已关闭')
    } else if (error.response.status === 403) {
      if (error.response.data) {
        Message.error(error.response.data.msg)
      } else {
        Message.error('服务器错误')
      }
    } else if (error.response.status === 400) {
      if (error.response.data) {
        Message.error(error.response.data.msg)
      } else {
        Message.error('服务器错误')
      }
    } else if (error.response.status === 404) {
      if (error.response.data.code === 'ER404') {
        Message.error(error.response.data.msg)
      } else {
        Message.error('资源没找到')
      }
    } else {
      Message.error('服务器错误')
    }
    return Promise.reject(error)
  })

function apiAxios (method, url, params, isJson, response, catchMethod, isDownload) {
  let config = {
    method: method,
    url: url,
    headers: isJson ? {'Content-Type': 'application/json;charset=utf-8'} : {'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8'},
    data: method === 'POST' || method === 'PUT' ? isJson ? JSON.stringify(params) : Qs.stringify(params) : null,
    params: method === 'GET' || method === 'DELETE' ? params : null
  }
  if (isDownload) config.responseType = 'arraybuffer'
  http(config).then(function (res) {
    // console.log(2231231)
    // debugger
    if (res&&res.data && res.data.hasOwnProperty('code')) {
      if (res.data.code === 'E1001') {
        MessageBox.alert('登陆失效，请重新登陆！', '警告', {
          confirmButtonText: '确定',
          callback: action => {
            backUrl()
          }
        })
        return
      }
    }
    response(res)
  }).catch((err) => {
    // loading.close()
    if (catchMethod) {
      catchMethod(err.response)
    } else {
      if (err.response) {
        let status = err.response.status
        switch (status) {
          case 404:
            Message.error('资源没有找到')
            break
          case 500:
            console.log(err.response)
            Message.error('服务器错误')
            // backUrl()
        }
      }
    }
  })
}

export default {
  get: function (url, params, response, catchMethod) {
    return apiAxios('GET', url, params, false, response, catchMethod, false)
  },
  post: function (url, params, response, catchMethod) {
    return apiAxios('POST', url, params, false, response, catchMethod, false)
  },
  postJson: function (url, params, response, catchMethod) {
    return apiAxios('POST', url, params, true, response, catchMethod, false)
  },
  put: function (url, params, response, catchMethod) {
    return apiAxios('PUT', url, params, false, response, catchMethod, false)
  },
  delete: function (url, params, response, catchMethod) {
    return apiAxios('DELETE', url, params, false, response, catchMethod, false)
  },
  postDownload: function (url, params, response, catchMethod) {
    return apiAxios('POST', url, params, false, response, catchMethod, true)
  }
}



// WEBPACK FOOTER //
// ./src/assets/http/index.js